<template>
  <v-dialog
    v-model="dialog"
    :max-width="!!options.width?options.width:290"
    :style="{ zIndex: 200 }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar
        dark
        :color="options.color"
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          {{ options.title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pb-1">
        <div
          v-if="!!options.message"
          class="py-4"
        >
          {{ options.message }}
        </div>
        <template v-if="options.form">
          <div
            v-for="(el, field) in options.form"
            :key="field"
          >
            <v-select
              v-if="el.type == 'select'"
              v-model="options.form[field].value"
              clearable
              :error-messages="$v.options.form[field] ? ($v.options.form[field].$dirty && $v.options.form[field].$error? ['This field is required'] : []) : [] "
              solo
              :label="el.label || null"
              :placeholder="el.label? null :(el.placeholder || null)"
              :items="el.values || el.items || []"
            />
            <v-text-field
              v-else-if="el.type=='text'"
              v-model="options.form[field].value"
              clearable
              :error-messages="$v.options.form[field] ? ($v.options.form[field].$dirty && $v.options.form[field].$error? ['This field is required'] : []) : [] "
              solo
              :label="el.label || null"
              :placeholder="el.label? null :(el.placeholder || null)"
            />
          </div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions class="text-center">
        <v-col class="pt-1 pb-1">
          <v-btn
            d-inline
            color="primary"
            @click.native="agree"
          >
            {{ options.confirmBtnText }}
          </v-btn>
          <v-btn
            text
            @click.native="cancel"
          >
            {{ options.cancelBtnText }}
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import _ from 'lodash'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  export default {
    mixins: [validationMixin],
    data: () => ({
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 290,
        title: '',
        message: '',
        confirmBtnText: 'Yes',
        cancelBtnText: 'Cancel',
        form: null,
      },
    }),
    validations () {
      var validate = {}
      if (this.options.form) {
        _.map(this.options.form, (el, field) => {
          if (el.required) { validate[field] = { value: { required } } }
        })
      }
      return { options: { form: validate } }
    },
    watch: {
      '$store.state.app.confirmLine' (vn, vo) {
        const conf = vn[vn.length - 1]
        this.open(conf)
      },
    },
    methods: {
      open (options) {
        this.options = options
        this.dialog = true
        this.$v.$reset()
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree () {
        this.$v.$touch()
        if (this.$v.options.form.$invalid) { return }

        if (this.options.onConfirm) {
          const args = {}
          if (this.options.form) {
            _.map(this.options.form, (el, field) => {
              args[field] = el.value
            })
          }
          this.options.onConfirm(args)
        }
        this.dialog = false
        this.resolve(true)
      },
      cancel () {
        this.resolve(false)
        if (this.options.onCancel) { this.options.onCancel() }
        this.dialog = false
      },
    },
  }
</script>
